import { useState } from "react";
import { useMarketName } from "app/pages/industry-analysis/market-builder/CustomHooks/useMarketName";
import Sentry from "@similarweb/sentry-logger";
import { createMarket } from "./services/createMarket";
import SegmentsApiService from "app/services/segments/segmentsApiService";
import type { INavigateToPlayers } from "./services/navigateToPlayers";
import { navigateToPlayers } from "./services/navigateToPlayers";
import { getCountryFromFC } from "./utils/utils";

export const useMarket = (initialName: string) => {
    const [allowSave, setAllowSave] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { marketName, onUpdateMarketName, hasErrorWithName, nameErrorMessage } = useMarketName({
        name: initialName,
    });
    const segmentsApiService = SegmentsApiService.getInstance();

    const saveMarket = async (marketName: string, segmentGroupId: string): Promise<void> => {
        setIsLoading(true);
        setAllowSave(false);
        try {
            await createMarket(marketName, segmentGroupId);
            await segmentsApiService.refreshSegmentsMetaData(); // we need to refresh the segments metadata so that the homepage group list will be updated with the currect data
            const country = getCountryFromFC();
            const navigateParams: INavigateToPlayers = { marketName };
            if (country) {
                navigateParams.country = country;
            }
            navigateToPlayers(navigateParams);
        } catch (error) {
            Sentry.error("had problems with saveMarket function in convertIntoIndustry:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        marketName,
        onUpdateMarketName,
        hasErrorWithName,
        nameErrorMessage,
        allowSave,
        setAllowSave,
        isLoading,
        saveMarket,
    };
};
